<template>
  <SlideOver
    v-model="open"
    id="actions-slide-over"
    :title="$t('components.actions-slide-over.title')"
  >
    <Actions
      @open-task-slide-over="onOpenTaskSlideOver"
      @open-client-slide-over="onOpenClientSlideOver"
      @open-client-link-slide-over="onOpenClientLinkSlideOver"
      @open-client-group-slide-over="onOpenClientGroupSlideOver"
      @close="open = false"
    />
  </SlideOver>

  <template v-if="selectedRollout">
    <ClientTaskSlideOver v-model="showTaskSlideOver" />

    <ClientSlideOver v-model="showClientSlideOver" />

    <ClientLinkSlideOver v-model="showClientLinkSlideOver" />

    <ClientGroupSlideOver v-model="showClientGroupSlideOver" />
  </template>
</template>

<script lang="ts" setup>
import Actions from './Actions.vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const open = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

const { selectedRollout } = useRolloutRouting();

const showTaskSlideOver = ref(false);
const showClientSlideOver = ref(false);
const showClientLinkSlideOver = ref(false);
const showClientGroupSlideOver = ref(false);

const onOpenTaskSlideOver = () => {
  open.value = false;
  showTaskSlideOver.value = true;
};

const onOpenClientSlideOver = () => {
  open.value = false;
  showClientSlideOver.value = true;
};

const onOpenClientLinkSlideOver = () => {
  open.value = false;
  showClientLinkSlideOver.value = true;
};

const onOpenClientGroupSlideOver = () => {
  open.value = false;
  showClientGroupSlideOver.value = true;
};
</script>
